import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const CustomFormulaPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "CustomFormulaPage" */ './Container'),
  'page'
);
